var map = {
	"./address.svg": "25c4",
	"./car.svg": "eeac",
	"./douyin.svg": "ee76",
	"./em.svg": "8c10",
	"./kefu.svg": "86da",
	"./logo.svg": "d9b6",
	"./more.svg": "d5d3",
	"./phone.svg": "b470",
	"./phones.svg": "c08c",
	"./top.svg": "e10f",
	"./us1.svg": "d1bf",
	"./us2.svg": "f1e1",
	"./us3.svg": "5ab6",
	"./us4.svg": "3813",
	"./us5.svg": "3a7b",
	"./w.svg": "c535",
	"./wLogo.svg": "d349",
	"./we.svg": "91c3",
	"./weibo.svg": "21c7",
	"./weixin.svg": "e067",
	"./wh1.svg": "e673",
	"./wh2.svg": "ba43",
	"./wh3.svg": "68fc",
	"./wh4.svg": "0cd5",
	"./wh5.svg": "c1d6",
	"./xcx.svg": "fcef",
	"./xiaochengxu.svg": "aa0f",
	"./ys1.svg": "3e17",
	"./ys2.svg": "da5e",
	"./ys3.svg": "ad43",
	"./ys4.svg": "b880",
	"./ys5.svg": "3778",
	"./ys6.svg": "f8ee",
	"./zLogo.svg": "17bc",
	"./zhuangshi.svg": "7c72",
	"./zixun.svg": "feee",
	"./zuozi.svg": "243f",
	"./zzi.svg": "c289"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";